import { FlyInFlyOutDuration, WorkingHours, WorkScheduleByDays } from '@hh.ru/types-hh-microcore';

export const isOtherValue = (value: FlyInFlyOutDuration | WorkScheduleByDays | WorkingHours): boolean =>
    value === FlyInFlyOutDuration.Other || value === WorkScheduleByDays.Other || value === WorkingHours.Other;
